<div class="influencer-posts-container">
    <app-post-list #PostList *ngIf="!hasNoData && imageReady"
        (openIncompleteStory)="openIncompleteStory.emit($event)"
        [postList]="postList"
        [influencerGroupId]="influencerGroupId"
        [showMoreheight]="'730px'"
        [columnWidth]="192"
        [keepOrder]="true"
        [gutter]="0" >
    </app-post-list>
    
    <influencer-posts-placeholder *ngIf="hasNoData || isFetchingData || !imageReady"
        [isFetchingData]="isFetchingData"
        [hasNoData]="hasNoData">
    </influencer-posts-placeholder>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/influencer-posts/influencer-posts.component.html